import { render, staticRenderFns } from "./multipeChoice.vue?vue&type=template&id=2e013f5c&lang=pug"
import script from "./multipeChoice.vue?vue&type=script&lang=js"
export * from "./multipeChoice.vue?vue&type=script&lang=js"
import style0 from "./multipeChoice.vue?vue&type=style&index=0&id=2e013f5c&prod&lang=stylus&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports